import { render, staticRenderFns } from "./qualities.vue?vue&type=template&id=b4c63382&scoped=true&lang=pug&"
import script from "./qualities.vue?vue&type=script&lang=coffee&"
export * from "./qualities.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c63382",
  null
  
)

export default component.exports